export enum Links {
  HOME = '/',
  ABOUT = '/sobre-mim',
  PROJECTS = '/projetos',
}
